import styled from 'styled-components';
import { SchedCardContainer } from '../../../styles';

export const Title = styled.span`
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 250px;
`;

export const DamSchedContainer = styled(SchedCardContainer)`
  @media (max-width: 768px) {
    min-width: auto;
    width: 70vw;
    height: max-content;
  }

  height: auto;
`;

export const DaysContainer = styled.div`
  display: flex;
  padding-top: 10px;
  font-size: 90%;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
